import { Box, LinearProgress } from "@mui/material";

export const PageTopLoader = () => {
  return (
    <Box sx={{ width: "100%", position: "fixed" }}>
      <LinearProgress />
    </Box>
  );
};
